import React, { memo, useState } from 'react';
import { View } from 'react-native';

import { Utils, EditAvatar, Avatar } from '../components';

function cachedBustedURI(uri) {
  return `${uri}${uri.includes('?') ? '&' : '?'}t=${new Date().getTime()}`;
}

const LogoForm = memo((props) => {
  const employer = props.employer || {};
  const imageSource = employer?.employerId
    ? cachedBustedURI(Utils.employerImagePath(employer?.employerId))
    : null;

  const [uploadImage, setUploadImage] = useState(null);

  function handleImageSelected(imageData) {
    setUploadImage(imageData);
    props.onImageDataChange(imageData);
  }

  return (
    <View style={{ marginBottom: 20, backgroundColor: '#EEEEEE' }}>
      <EditAvatar onSelectImage={handleImageSelected} readOnly={props.readOnly}>
        <Avatar
          initialsStr={null}
          onPress={null}
          avatarUrl={uploadImage?.image?.uri || imageSource || null}
        />
      </EditAvatar>
    </View>
  );
});

export default LogoForm;
